import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import Button from '../Button';
import './index.scss'; 

const DefaultModal = ({
  image,
  title,
  isOpenModal,
  onToggleModal,
  description,
  primaryButton,
  descriptionImage,
  secondaryButton
}) => {
  const fontStyle = {
    fontFamily: 'Brinnan', 
  };

  return (
    <Modal
      className="tbx-modal-container"
      isOpen={isOpenModal}
      toggle={onToggleModal}
      fade={false}
      centered
      backdrop="static" 
      keyboard={false}
    >
      <ModalHeader className="tbx-modal-container__header" style={fontStyle}>
        {image && (
          <div className="image">
            {image}
          </div>
        )}
        {title}
      </ModalHeader>
      <ModalBody className="tbx-modal-container__body" style={fontStyle}>
        {descriptionImage && (
          <div className="image">
            {descriptionImage}
          </div>
        )}
        <p className="tbx-modal-container__description">{description}</p>
      </ModalBody>
      <ModalFooter className="tbx-modal-container__footer" style={{ justifyContent: 'center' }}>
        {primaryButton && (
          <div>
            <Button
              isNeutral={primaryButton.isNeutral || true}
              text={primaryButton?.text}
              onClick={primaryButton?.onClick}
              isSubmitting={primaryButton?.isSubmitting}
              style={fontStyle}
            />
          </div>
        )}
        {secondaryButton && (
          <div>
            <Button
              isNeutral={secondaryButton.isNeutral || false}
              text={secondaryButton?.text}
              onClick={secondaryButton?.onClick}
              isSubmitting={secondaryButton?.isSubmitting}
              disabled={secondaryButton?.disabled}
              style={fontStyle}
            />
          </div>
        )}
      </ModalFooter>
    </Modal>
  );
};

DefaultModal.propTypes = {
  image: PropTypes.any,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isOpenModal: PropTypes.bool,
  onToggleModal: PropTypes.func,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  descriptionImage: PropTypes.any,
  primaryButton: PropTypes.shape({
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isNeutral: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    onClick: PropTypes.func,
  }),
  secondaryButton: PropTypes.shape({
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isNeutral: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
  })
};
export default DefaultModal;
